import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WithSidebar from 'Layout/WithSidebar';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import ProductItems from 'components/ProductItems';
import Filter from 'components/Filter';
import Banner from 'components/Banner';
import { trialResults } from 'components/Filter/mockData';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';
import {
    fetchTrialResults,
    fetchTrialResultsPageList,
    selectTrialResultsPage,
    selectTrialResultsPageList,
} from 'store/slices/TrialResults';
import { ROUTES } from 'constants/routes';

// TODO add filters
const TrialResults = () => {
    const dispatch = useDispatch();
    const {
        fs_title,
        fs_title_background,
        fs_view_button,
        agricultural_tag,
        agricultural_title,
        agricultural_description,
    } = useSelector(selectTrialResultsPage);

    const crops = useSelector(selectTrialResultsPageList);

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchTrialResultsPageList({ all: true }));
        // @ts-ignore
        dispatch(fetchTrialResults());
    }, [dispatch]);

    return (
        <>
            <Banner title={fs_title} image={fs_title_background} buttonText={fs_view_button} />

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>{agricultural_tag}</LabelButton>
                        <GradientText>
                            <span dangerouslySetInnerHTML={{ __html: agricultural_title }} />
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small">
                                <span dangerouslySetInnerHTML={{ __html: agricultural_description }} />
                            </GradientText>
                        </div>
                    </div>
                </div>

                <WithSidebar Sidebar={<Filter data={trialResults} />}>
                    <div className="box">
                        <ProductItems data={crops} baseRoute={ROUTES.trialResults} />
                    </div>
                </WithSidebar>
            </section>

            <DefaultForm />
        </>
    );
};

export default TrialResults;
